// extracted by mini-css-extract-plugin
export default {"modalBackground":"SaveLoad_modalBackground__+yrH9","modalForeground":"SaveLoad_modalForeground__fvGJA"};